"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var embed_exports = {};
__export(embed_exports, {
  EmbedNode: () => EmbedNode
});
module.exports = __toCommonJS(embed_exports);
var import_core = require("@tiptap/core");
const EmbedNode = import_core.Node.create({
  name: "embed",
  addOptions() {
    return {};
  },
  inline: false,
  group: "block",
  atom: false,
  draggable: false,
  addAttributes() {
    return {
      src: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        priority: 60,
        tag: `figure[data-type="${this.name}"] iframe[src]`
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["figure", { "data-type": this.name }, ["iframe", (0, import_core.mergeAttributes)(HTMLAttributes)]];
  }
});
//# sourceMappingURL=embed.js.map
